const NEW_PRODUCT_LAUNCH_DATES: Record<string, string> = {
  liberty: "2026-09-07T00:00:00Z",
  texas: "2026-09-07T00:00:00Z",
  dadgum: "2026-09-07T00:00:00Z",
  bronc: "2026-09-07T00:00:00Z",
  founders: "2026-09-07T00:00:00Z",
  rise: "2026-09-07T00:00:00Z",
  flush: "2026-09-07T00:00:00Z",
  saloon: "2026-09-07T00:00:00Z",
};

const NEW_BADGE_DURATION_MS = 30 * 24 * 60 * 60 * 1000;

export function hasActiveNewBadge(handle: string, now = Date.now()) {
  const launchDate = NEW_PRODUCT_LAUNCH_DATES[handle.toLowerCase()];
  if (!launchDate) return false;

  const launchTime = Date.parse(launchDate);
  return now >= launchTime && now < launchTime + NEW_BADGE_DURATION_MS;
}